const buyerReviewAndCorrectHeadCells = [
    { id: "checkInDate", label: "CHECK IN"},
    { id: 'checkOutDate', label: 'CHECK OUT' },
    { id: 'chassisNumber', label: 'CHASSIS' },
    { id: 'containerNumber', label: 'CONTAINER' },
    { id: 'trailerNumber', label: 'TRAILER' },
    { id: "truckLicensePlateNumber", label: "TRUCK LICENSE PLATE"},
    { id: 'supplierName', label: 'SUPPLIER' },
    { id: 'locationName', label: 'LOCATION' },
    { id: 'orderNumber', label: 'BOOKING' },
    { id: 'dwellTime', label: 'DWELL TIME' },
    { id: 'assetType', label: 'EQUIPMENT' },
    { id: "assetSize", label: "SIZE"},
    { id: "checkInDriverName", label: "CHECK IN DRIVER"},
    { id: "checkinDriverLicenseNumber", label: "CHECK IN LICENSE"},
    { id: "checkOutDriverName", label: "CHECK OUT DRIVER"},
    { id: "checkoutDriverLicenseNumber", label: "CHECK OUT LICENSE"},
    { id: "existingCorrections", label: "EXISTING CORRECTIONS"}
];

const submittedCorrectionSortByFields = [
{ value: "CREATION_DATE", label: "Creation Date" },
{ value: "ORDER_NUMBER", label: "Booking Number" },
{ value: "STATUS", label: "Status" },
{ value: "SUPPLIER_NAME", label: "Supplier Name"},
{ value: "LOCATION_NAME", label: "Location Name" },
];

const interchangeSortByFields = [
    {label: "Date", value: "ACTIVITY_DATE"},
    {label: "Supplier", value: "SUPPLIER_NAME"},
    {label: "Location", value: "LOCATION_NAME"},
    {label: "Container Number", value: "CONTAINER_NUMBER"},
    {label: "Chassis Number", value: "CHASSIS_NUMBER"},
    {label: "Truck License Plate", value: "TRUCK_LICENSE_PLATE_NUMBER"},
    {label: "Trailer Number", value: "TRAILER_NUMBER"},
    {label: "Driver Last Name", value: "DRIVER_LAST_NAME"},
    {label: "Asset Size", value: "ASSET_SIZE"},
];

export {buyerReviewAndCorrectHeadCells, submittedCorrectionSortByFields, interchangeSortByFields};